import React, { useContext } from "react";
import { flushSync } from "react-dom";
import { useNavigate } from "react-router-dom";
import { InlineGroup, ReactForm, Section, Button, InputField } from "mta-rkvr-styles";
import CurrentUserContext from "../CurrentUserContext";

const backEndBase = window.backEndBase;

export function logout(navigate: any, toggleRefresh: Function) {
  const headers = new Headers();
  headers.set("Accept", "application/json");
  headers.set("Content-Type", "application/json");
  fetch(`${backEndBase}/logout`, {
    method: "POST",
    headers,
  }).then((response) => {
    if (response.ok) {
      flushSync(() => {
        toggleRefresh();
      });
      navigate("/");
    }
  });
}

export function rolePost(id: string | null, navigate: any, toggleRefresh: Function) {
  const postData = id;
  const headers = new Headers();
  headers.set("Accept", "application/json");
  headers.set("Content-Type", "application/json");
  fetch(`${backEndBase}/auth/devlogin/login`, {
    method: "POST",
    headers,
    body: JSON.stringify(postData),
  }).then((response) => {
    if (response.ok) {
      flushSync(() => {
        toggleRefresh();
      });
      navigate("/");
    }
  });
}

const Roles: React.FC<{ toggleRefresh: Function }> = ({ toggleRefresh }) => {
  const { authenticate } = useContext(CurrentUserContext);

  const navigate = useNavigate();
  const onSubmit = (e: any) => {
    console.log(e);
    rolePost(e.userId, navigate, toggleRefresh);
  };

  const takeRolePresetAdministraatorII = () => {
    rolePost("37310056515", navigate, toggleRefresh);
  };
  const takeRolePresetRegistripidajaII = () => {
    rolePost("48005234723", navigate, toggleRefresh);
  };
  const takeRolePresetKinnitajaII = () => {
    rolePost("47103152746", navigate, toggleRefresh);
  };
  const takeRolePresetRegistriHaldurII = () => {
    rolePost("48806260018", navigate, toggleRefresh);
  };
  const takeRolePresetVaatlejaII = () => {
    rolePost("38709250011", navigate, toggleRefresh);
  };
  const takeRolePresetHuvilineII = () => {
    rolePost("39003090033", navigate, toggleRefresh);
  };
  const takeRolePresetVaraarvestusII = () => {
    rolePost("47007070210", navigate, toggleRefresh);
  };
  const takeRolePresetKvyHaldurII = () => {
    rolePost("46408226010", navigate, toggleRefresh);
  };
  const takeRolePresetJkKoordinaatorII = () => {
    rolePost("38007024252", navigate, toggleRefresh);
  };
  const takeRolePresetJkKoostajaII = () => {
    rolePost("48704224913", navigate, toggleRefresh);
  };
  const takeRolePresetKinnitaja = () => {
    rolePost("38905202719", navigate, toggleRefresh);
  };
  const takeRolePresetPeakasutaja = () => {
    rolePost("37006204210", navigate, toggleRefresh);
  };
  const takeRolePresetRegistrihaldur = () => {
    rolePost("49012315213", navigate, toggleRefresh);
  };
  const takeRolePresetRegistripidaja = () => {
    rolePost("49312060853", navigate, toggleRefresh);
  };
  const takeRolePresetVaatleja = () => {
    rolePost("37912314223", navigate, toggleRefresh);
  };
  const takeRolePresetVaraarvestus = () => {
    rolePost("48508070014", navigate, toggleRefresh);
  };
  const takeRolePresetHuviline = () => {
    rolePost("48908282736", navigate, toggleRefresh);
  };
  const takeRolePresetPuudub = () => {
    rolePost("47506290281", navigate, toggleRefresh);
  };
  const takeRolePresetRegistripidaja2 = () => {
    rolePost("39301260341", navigate, toggleRefresh);
  };
  const takeRolePresetKinnitaja2 = () => {
    rolePost("39505062728", navigate, toggleRefresh);
  };
  const takeRolePresetHaldurII = () => {
    rolePost("36312290210", navigate, toggleRefresh);
  };

  return (
    <>
      <Section title={"RKVR II kasutajad"}>
        <ReactForm onSubmit={onSubmit}>
          <InlineGroup>
            <Button
              label={"Kasuta: ADMINISTRAATOR - 37310056515"}
              type={"button"}
              onClick={takeRolePresetAdministraatorII}
            />
            <Button
              label={"Kasuta: REGISTRIPIDAJA - 48005234723"}
              type={"button"}
              onClick={takeRolePresetRegistripidajaII}
            />
          </InlineGroup>
          <br />
          <InlineGroup>
            <Button label={"Kasuta: KINNITAJA - 47103152746"} type={"button"} onClick={takeRolePresetKinnitajaII} />
            <Button
              label={"Kasuta: REGISTRI-HALDUR - 48806260018"}
              type={"button"}
              onClick={takeRolePresetRegistriHaldurII}
            />
          </InlineGroup>
          <br />
          <InlineGroup>
            <Button label={"Kasuta: VAATLEJA - 38709250011"} type={"button"} onClick={takeRolePresetVaatlejaII} />
            <Button label={"Kasuta: HUVILINE - 39003090033"} type={"button"} onClick={takeRolePresetHuvilineII} />
          </InlineGroup>
          <br />
          <InlineGroup>
            <Button
              label={"Kasuta: VARAARVESTUS - 47007070210"}
              type={"button"}
              onClick={takeRolePresetVaraarvestusII}
            />
            <Button label={"Kasuta: KVY-HALDUR - 46408226010"} type={"button"} onClick={takeRolePresetKvyHaldurII} />
          </InlineGroup>
          <br />
          <InlineGroup>
            <Button
              label={"Kasuta: JK-KOORDINAATOR - 38007024252"}
              type={"button"}
              onClick={takeRolePresetJkKoordinaatorII}
            />
            <Button label={"Kasuta: JK-KOOSTAJA - 48704224913"} type={"button"} onClick={takeRolePresetJkKoostajaII} />
          </InlineGroup>
          <br />
          <InlineGroup>
            <Button
              label={"Kasuta: REG-HALDUR/KVY-HALDUR - 36312290210"}
              type={"button"}
              onClick={takeRolePresetHaldurII}
            />
          </InlineGroup>
          <br />
          <InlineGroup>
            <InputField name={"userId"} />
            <Button label={"Kasuta ise sisestatud isikukoodi"} type={"submit"} />
          </InlineGroup>
        </ReactForm>
      </Section>
      <Section title={"Sisene Keycloak abil"}>
        <Button onClick={authenticate}>Sisene</Button>
      </Section>
      <Section title={"RKVR I kasutajad"}>
        <ReactForm onSubmit={onSubmit}>
          <InlineGroup>
            <Button label={"Kasuta: Kinnitaja - 38905202719"} type={"button"} onClick={takeRolePresetKinnitaja} />
            <Button label={"Kasuta: Peakasutaja - 37006204210"} type={"button"} onClick={takeRolePresetPeakasutaja} />
          </InlineGroup>
          <br />
          <InlineGroup>
            <Button
              label={"Kasuta: Registri-haldur - 49012315213"}
              type={"button"}
              onClick={takeRolePresetRegistrihaldur}
            />
            <Button
              label={"Kasuta: Registripidaja - 49312060853"}
              type={"button"}
              onClick={takeRolePresetRegistripidaja}
            />
          </InlineGroup>
          <br />
          <InlineGroup>
            <Button label={"Kasuta: Vaatleja - 37912314223"} type={"button"} onClick={takeRolePresetVaatleja} />
            <Button label={"Kasuta: Varaarvestus - 48508070014"} type={"button"} onClick={takeRolePresetVaraarvestus} />
          </InlineGroup>
          <br />
          <InlineGroup>
            <Button label={"Kasuta: Huviline - 48908282736"} type={"button"} onClick={takeRolePresetHuviline} />
            <Button label={"Kasuta: Puudub - 47506290281"} type={"button"} onClick={takeRolePresetPuudub} />
          </InlineGroup>
          <br />
          <InlineGroup>
            <Button
              label={"Kasuta: Registripidaja - 39301260341"}
              type={"button"}
              onClick={takeRolePresetRegistripidaja2}
            />
            <Button label={"Kasuta: Kinnitaja - 39505062728"} type={"button"} onClick={takeRolePresetKinnitaja2} />
          </InlineGroup>
        </ReactForm>
      </Section>
    </>
  );
};

export default Roles;
